/**
 * Inline SVG mockup of a PayPal payment receipt so a first-time customer
 * can SEE what we're asking them to send. Designed to match the real
 * PayPal mobile receipt layout closely enough that players recognise it
 * but with sample data so there's zero ambiguity about what each field
 * is. Pure inline SVG — no external image hosting, no network calls.
 */
export const ExampleReceiptSVG = ({ className = '' }) => (
    <svg
        viewBox="0 0 320 540"
        xmlns="http://www.w3.org/2000/svg"
        className={className}
        role="img"
        aria-label="Example PayPal receipt"
        data-testid="example-receipt-svg"
    >
        {/* Card background */}
        <rect x="0" y="0" width="320" height="540" rx="18" fill="#ffffff" />
        <rect x="0" y="0" width="320" height="64" rx="18" fill="#003087" />

        {/* PayPal logo (text mark) */}
        <text x="20" y="40" fontFamily="Arial, sans-serif" fontSize="22" fontWeight="700" fill="#fff">Pay</text>
        <text x="56" y="40" fontFamily="Arial, sans-serif" fontSize="22" fontWeight="700" fill="#009cde">Pal</text>

        {/* Big checkmark + Sent label */}
        <circle cx="160" cy="110" r="22" fill="#0070ba" />
        <path d="M150 110 l8 8 l14 -16" stroke="#fff" strokeWidth="3.2" fill="none" strokeLinecap="round" strokeLinejoin="round" />
        <text x="160" y="158" textAnchor="middle" fontFamily="Arial, sans-serif" fontSize="13" fill="#7b8a99">You sent</text>

        {/* Amount */}
        <text x="160" y="200" textAnchor="middle" fontFamily="Arial, sans-serif" fontSize="42" fontWeight="800" fill="#001435">$25.00</text>
        <text x="160" y="222" textAnchor="middle" fontFamily="Arial, sans-serif" fontSize="11" fill="#7b8a99">to BETohalics</text>

        {/* Divider */}
        <line x1="24" y1="252" x2="296" y2="252" stroke="#e6eaef" strokeWidth="1" />

        {/* Field rows */}
        <g fontFamily="Arial, sans-serif" fontSize="11" fill="#001435">
            <text x="24" y="280" fill="#7b8a99">Date</text>
            <text x="296" y="280" textAnchor="end" fontWeight="600">Feb 24, 2026, 3:15 PM</text>

            <text x="24" y="308" fill="#7b8a99">Recipient</text>
            <text x="296" y="308" textAnchor="end" fontWeight="600">BETohalics</text>

            <text x="24" y="336" fill="#7b8a99">Payment method</text>
            <text x="296" y="336" textAnchor="end" fontWeight="600">Visa ••••1234</text>

            <text x="24" y="364" fill="#7b8a99">Transaction ID</text>
            <text x="296" y="364" textAnchor="end" fontWeight="600" fontFamily="monospace" fontSize="10">8AB12345CD678901E</text>

            <text x="24" y="392" fill="#7b8a99">Status</text>
            <text x="296" y="392" textAnchor="end" fontWeight="700" fill="#1d8e3a">Completed</text>
        </g>

        {/* Highlighted callouts overlaid on important rows */}
        <rect x="14" y="190" width="292" height="22" rx="4" fill="none" stroke="#39FF14" strokeWidth="2" strokeDasharray="3 3" />
        <rect x="14" y="350" width="292" height="22" rx="4" fill="none" stroke="#39FF14" strokeWidth="2" strokeDasharray="3 3" />

        {/* Footer note */}
        <rect x="0" y="450" width="320" height="90" fill="#f3f6fa" />
        <text x="160" y="478" textAnchor="middle" fontFamily="Arial, sans-serif" fontSize="11" fill="#001435" fontWeight="700">
            Make sure these are visible:
        </text>
        <text x="160" y="498" textAnchor="middle" fontFamily="Arial, sans-serif" fontSize="10.5" fill="#001435">
            ✓ Amount   ✓ Transaction ID
        </text>
        <text x="160" y="516" textAnchor="middle" fontFamily="Arial, sans-serif" fontSize="10.5" fill="#001435">
            ✓ Date &amp; time   ✓ Recipient (BETohalics)
        </text>
    </svg>
);

export default ExampleReceiptSVG;
